import CampaignList from './CampaignList';
import { CAMPAIGN } from './campaign.navigation';

const campaignRoute = { ...CAMPAIGN, component: CampaignList };

export default campaignRoute;
